import { config } from '@abyss/api/tools/config';
import { dataSource } from '@abyss/api/tools/dataSource/rest';
import qs from 'qs';

import { loadSecrets } from '../../tools/loadSecrets';
import { APIConstants } from '../Constants';

const cachedHCPAuth = {};

export const hcpTokenService = {
  getHCPToken: async (
    tokenEnv,
    contextValue,
    scopeValue: string = APIConstants.OAUTH_SCOPE.DEFAULT_SCOPE,
    isPsxHcp: boolean = false
  ) => {
    const cacheKey = `${tokenEnv}:${scopeValue}`;

    if (cachedHCPAuth[cacheKey]) {
      return cachedHCPAuth[cacheKey];
    }

    const tokenAPI = dataSource({
      url: config(`HCP_API_URL_${tokenEnv}`),
      customAxios: contextValue.customAxios,
    });
    if (
      process.env.NODE_ENV !== 'development' &&
      process.env.NODE_ENV !== 'test' &&
      !process.env.SECRETS_READY
    ) {
      await loadSecrets();
    }

    const getClientIdKeyPrefix = () => {
      if (isPsxHcp) return 'PSX_HCP_API_CLIENT_ID';
      return 'HCP_API_CLIENT_ID';
    };

    const getClientSecretKeyPrefix = () => {
      if (isPsxHcp) return 'PSX_HCP_API_CLIENT_SECRET';
      return 'HCP_API_CLIENT_SECRET';
    };

    const clientID = process.env[`${getClientIdKeyPrefix()}_${tokenEnv}`];

    const clientSecret =
      process.env[`${getClientSecretKeyPrefix()}_${tokenEnv}`];

    const body = {
      client_id: clientID,
      client_secret: clientSecret,
      grant_type: 'client_credentials',
      scope: scopeValue,
    };

    const { data } = await tokenAPI({
      method: 'POST',
      path: '/oauth2/token',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(body),
      onSuccess: (response) => response,
      onError: (error) => {
        throw error;
      },
    });

    cachedHCPAuth[cacheKey] = data.access_token;

    setTimeout(() => {
      delete cachedHCPAuth[cacheKey];
    }, 1000 * data.expires_in - 10 * 1000);

    return cachedHCPAuth[cacheKey];
  },
};
